import { matchPath, useNavigate } from "react-router-dom";

import { ROUTES } from "../router";

interface ProviderToolsMenuOptions {
  label: string;
  onClick: () => void;
  enabled: boolean;
  current?: boolean;
}

export const useGetToolsLayoutMenuOptions = () => {
  const navigate = useNavigate();

  const actualPath = window.location.pathname;

  const menuOptions: ProviderToolsMenuOptions[] = [
    {
      label: "General",
      onClick: () => {
        navigate(ROUTES.toolsGeneral);
      },
      current: !!matchPath(ROUTES.toolsGeneral, actualPath),
      enabled: true,
    },
    {
      label: "Consultation options",
      onClick: () => {
        navigate(ROUTES.toolsConsultationOptions);
      },
      current: !!matchPath(ROUTES.toolsConsultationOptions, actualPath),
      enabled: true,
    },
    {
      label: "Consultation links",
      onClick: () => {
        navigate(ROUTES.toolsConsultationLinks);
      },
      current: !!matchPath(ROUTES.toolsConsultationLinks, actualPath),
      enabled: true,
    },
    {
      label: "Integrations",
      onClick: () => {
        navigate(ROUTES.toolsIntegrations);
      },
      current: !!matchPath(ROUTES.toolsIntegrations, actualPath),
      enabled: true,
    },
  ];

  return { menuOptions };
};
